import {TFunction} from "i18next";


export interface UseLanguageReturn {
    currentLanguage: string;
    changeLanguage: (lng: string) => void;
    t: TFunction;
    isRTL: boolean;
}

// Interface pour les langues dans le sélecteur
export interface Language {
    code: string;
    name: string;
    flag: string;
}


export const getCountryFromLanguage = (language: string): string => {
    switch (language) {
        case 'ar':
            return 'SA'; // Arabie Saoudite
        case 'en':
            return 'SA'; // Anglais pour le marché saoudien
        case 'fr':
        default:
            return 'FR'; // France
    }
};

// Configuration des devises selon la langue/pays
export const getCurrencyFromLanguage = (language: string): string => {
    switch (language) {
        case 'ar':
        case 'en':
            return 'SAR';
        case 'fr':
        default:
            return 'EUR';
    }
};

// Configuration des taux de TVA selon le pays
export const getVATRateFromLanguage = (language: string): number => {
    switch (language) {
        case 'ar':
        case 'en':
            return 0.15; // 15% en Arabie Saoudite
        case 'fr':
        default:
            return 0.20; // 20% en France
    }
};

// Configuration des prix de base selon le pays
export const getBasePriceFromLanguage = (language: string): number => {
    switch (language) {
        case 'ar':

            return 299; // 150 SA
        case 'en':
        case 'fr':
        default:
            return 49; // 49 EUR
    }
};